import { t } from 'i18next';

import { PaymentProviderStatus } from 'types/pwcOrder';

const STATUS_LABELS: Record<PaymentProviderStatus, [string, string]> = {
  [PaymentProviderStatus.PENDING]: ['page.pwcOrders.components.status.pending', 'Pending'],
  [PaymentProviderStatus.SUCCEEDED]: ['page.pwcOrders.components.status.succeeded', 'Succeeded'],
  [PaymentProviderStatus.FAILED]: ['page.pwcOrders.components.status.failed', 'Failed'],
};

export const LABELS = {
  STATUS: STATUS_LABELS,
};

export const badgePropsMap: Record<PaymentProviderStatus, { type: PaymentProviderStatus; label: string }> = {
  [PaymentProviderStatus.PENDING]: {
    type: PaymentProviderStatus.PENDING,
    label: t(LABELS.STATUS.pending),
  },
  [PaymentProviderStatus.SUCCEEDED]: {
    type: PaymentProviderStatus.SUCCEEDED,
    label: t(LABELS.STATUS.succeeded),
  },
  [PaymentProviderStatus.FAILED]: {
    type: PaymentProviderStatus.FAILED,
    label: t(LABELS.STATUS.failed),
  },
};
